module.exports = __webpack_public_path__ + "img/documents-ico.f3d9bfd4.svg";